import logExposure from 'experiments/services/logExposure';
import { ISignal } from 'shared/hooks/useAbortController';

/**
 * [logExperimentExposure]
 * This function is called when the inviewport event has been fired on a [data-experiment] element
 * are there any existing experiment on the client?
 * has the current experiment we are trying to log has already been logged
 * is user is assigned a group for the experiment?
 * is the experiment is still active
 * if all of the above is YES
 * then log the exposure
 * update localstorage
 * @param   {string} deviceId The deviceId with which we are logging all experiments
 * @param   {string} experimentName Experiment name
 * @param   {boolean} isAuthenticated whether the user is authenticated or not
 * @param   {Object} optionalMetaData metadata containing userId and sessionId if available
 * @param   {Object} signal AbortSignal to prevent unnecessary calls
 */

export function logExperimentExposure({
  deviceId,
  experimentName,
  isAuthenticated,
  optionalMetaData,
  signal,
}: {
  deviceId: string;
  experimentName: string;
  isAuthenticated: boolean;
  optionalMetaData: {
    sessionId?: string;
    userId?: string;
  };
  signal: ISignal;
}): Promise<any> {
  // non blocking
  return logExposure({
    deviceId,
    experimentName,
    isAuthenticated,
    optionalMetaData,
    signal,
  });
}
